/* eslint-disable no-empty-pattern */
import React, { useState, useContext, useEffect } from "react";
import Lottie from 'react-lottie';
import kudaFailureAnimation from '../../assets/animations/failure.json'
import { StateContext } from "../../contextApi";
import { closeModalOnClick } from "../../util/util";
import styled from "styled-components";

const BVNFailedModal = () => {

    const [state, setState] = useState({
        isStopped: true,
    })

    const [{bvnErrorMsg }, dispatch] = useContext(StateContext)


    const closeModal = async () => {
        dispatch({
            key: "bvnFailedForm",
            value: false,
            type: 'CHANGE_VIEW_MODALS',
            message: null
        });
    }


    const handleAnim = () => {
        setState({ isStopped: false })
    }

    useEffect(() => {
        document.body.classList.add("backdrop-init");
        closeModalOnClick(closeModal);
        return () => {
            document.body.classList.remove("backdrop-init");
        }
    }, [])

    const defaultOptions = {
        loop: false,
        autoplay: false,
        animationData: kudaFailureAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <DialBvnStyled>
            <div className="modal modal-sendMoney small-modal modal-backdrop fadeIn animated">
                <div className="modal-content fadeInUp animated">
                    <div className="kuda-modal--content">
                        <h4 className="color-black text-xbold margin-bottom--spacer text-center">BVN Verification Failed</h4>

                        <div className="kuda-modal-illustration">
                            <Lottie
                                options={defaultOptions}
                                height={`100%`}
                                width={`100%`}
                                isStopped={state.isStopped}
                                eventListeners={[
                                    {
                                        eventName: "DOMLoaded",
                                        callback: (anim) => handleAnim(anim),
                                    },
                                ]}
                            />
                        </div>

                        <div className="message-response withdrawal-response text-center bottom--spacing" style={{maxWidth: 'fit-content'}}>
                            <p className="color-black">We couldn’t verify your BVN. because {bvnErrorMsg}.</p>
                        </div>

                        <div className="dial-btn-wrap d-flex justify-content-center mt-5">
                            <div className="kuda-cta-outline kuda-cta-lg" onClick={closeModal}>Cancel</div>
                            <div className="addAction kuda-cta kuda-cta-lg" onClick={closeModal}>Retry</div>
                        </div>
                    </div>
                </div>
            </div>
        </DialBvnStyled>
    );
}

const DialBvnStyled = styled.div`

.dial-btn-wrap{
   gap: 22px;
}
.kuda-cta-lg{
    max-width: none;
}
`
export default BVNFailedModal;